import type { Action } from 'react-sweet-state';

import type { ValidationTargets } from '../../../../common/types/field-validation';
import type { FieldId, FormFields } from '../../../../common/types/form/form-fields';
import { fieldInvalidSelector } from '../../selectors/field-invalid';
import { getAllVisibleFieldIdsSelector } from '../../selectors/get-all-visible-field-ids';
import type { FormRendererState } from '../../types';

/**
 * This action has been updated to return the field IDs that have validation or custom errors.
 */
export const getFieldIdsFailingValidation =
	(
		validationTargets?: ValidationTargets,
		formFields?: FormFields,
	): Action<FormRendererState, void, FieldId[]> =>
	({ getState }) => {
		const state = getState();
		const effectiveStateForSelector = validationTargets
			? {
					...(formFields ? { ...state, formFields } : state),
					fieldValidation: { ...state.fieldValidation, validationTargets },
				}
			: { ...(formFields ? { ...state, formFields } : state) };

		const visibleFieldIds = getAllVisibleFieldIdsSelector(effectiveStateForSelector);

		const failingFieldIds = visibleFieldIds.reduce<FieldId[]>((accFailingFieldIds, fieldId) => {
			if (fieldInvalidSelector(effectiveStateForSelector, { fieldId })) {
				accFailingFieldIds.push(fieldId);
			}

			return accFailingFieldIds;
		}, []);

		return failingFieldIds;
	};
